import React, { useRef, useEffect } from 'react';

/**
 * 视频播放器组件
 * - 主播端：显示本地摄像头流
 * - 观众端：显示远程 WebRTC 流
 */
function VideoPlayer({ localStream, remoteStream, isHost }) {
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);

  // 绑定本地流
  useEffect(() => {
    if (localVideoRef.current && localStream) {
      localVideoRef.current.srcObject = localStream;
    }
  }, [localStream]);

  // 绑定远程流
  useEffect(() => {
    if (remoteVideoRef.current && remoteStream) {
      remoteVideoRef.current.srcObject = remoteStream;
    }
  }, [remoteStream]);

  return (
    <div className="relative w-full h-full bg-black rounded-lg overflow-hidden">
      {/* 主播本地视频 */}
      {isHost && (
        <video
          ref={localVideoRef}
          autoPlay
          muted
          playsInline
          className="w-full h-full object-contain"
        />
      )}

      {/* 观众远程视频 */}
      {!isHost && remoteStream && (
        <video
          ref={remoteVideoRef}
          autoPlay
          playsInline
          className="w-full h-full object-contain"
        />
      )}

      {/* 无流时的占位 */}
      {!localStream && !remoteStream && (
        <div className="flex items-center justify-center h-full text-gray-500">
          <div className="text-center">
            <div className="text-6xl mb-4">📺</div>
            <p className="text-lg">等待直播开始...</p>
          </div>
        </div>
      )}

      {/* 直播状态指示器 */}
      {localStream && (
        <div className="absolute top-4 left-4 flex items-center gap-2 bg-red-600 px-3 py-1 rounded-full">
          <span className="w-2 h-2 bg-white rounded-full live-dot"></span>
          <span className="text-sm font-semibold">LIVE</span>
        </div>
      )}
    </div>
  );
}

export default VideoPlayer;
